import React from 'react';

function HeartFill(props: object) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9209 18.0086C10.6266 18.1124 10.142 18.1124 9.84778 18.0086C7.33816 17.1518 1.73047 13.5778 1.73047 7.52012C1.73047 4.84608 3.88528 2.68262 6.54201 2.68262C8.11701 2.68262 9.51028 3.44416 10.3843 4.62108C11.2584 3.44416 12.6603 2.68262 14.2266 2.68262C16.8834 2.68262 19.0382 4.84608 19.0382 7.52012C19.0382 13.5778 13.4305 17.1518 10.9209 18.0086Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeartFill;
